<div class="change-complex-order dropdown-content-root">
	<div class="dropdown-title">
		<h4 class="title">{{ 'changeOrder.title' | translate }}</h4>
		<tui-icon
			class="close-icon"
			icon="@tui.x"
			(click)="onCloseDropdown()"
		/>
	</div>

	<div class="details">
		<div class="detail">
			<span class="title">{{ 'changeOrder.ticker' | translate }}</span>
			<span class="value">{{ order()?.symbol }}</span>
		</div>

		<div class="detail">
			<span class="title">{{ 'changeOrder.orderType' | translate }}</span>
			<span class="value">{{ order() | titleOrderType: true }}</span>
		</div>

		<div class="detail">
			<span class="title">{{ 'changeOrder.operation' | translate }}</span>
			<span
				class="value"
				highlight
				[isPositive]="order()?.side === orderSideEnum.BUY"
				[isNegative]="order()?.side === orderSideEnum.SELL"
				>{{ 'changeOrder.side.' + order()?.side | translate }}</span
			>
		</div>

		<div class="detail">
			<span class="title">{{ 'changeOrder.orderDuration' | translate }}</span>
			<span class="value">{{ order()?.time_in_force | uppercase }}</span>
		</div>

		<div class="detail">
			<span class="title">{{ 'changeOrder.quantity' | translate }}</span>
			<span class="value">{{ order()?.qty | quantity }}</span>
		</div>

		@if (isAveragePriceVisible()) {
			<div class="detail">
				<span class="title">{{ 'changeOrder.averagePrice' | translate }}</span>
				<span class="value">{{ order()?.avg_entry_price | price }}</span>
			</div>
		}

		@if (isLimitPriceVisible()) {
			<div class="detail">
				<span class="title">{{ 'changeOrder.limitPrice' | translate }}</span>
				<span class="value">{{ order()?.limit_price | price }}</span>
			</div>
		}

		@if (isStopPriceVisible()) {
			<div class="detail">
				<span class="title">{{ 'changeOrder.stopPrice' | translate }}</span>
				<span class="value">{{ order()?.stop_price | price }}</span>
			</div>
		}

		@if (takeProfit()) {
			<div class="detail">
				<span class="title">{{ 'changeOrder.attributes.take_profit' | translate }}</span>
				<span class="value">{{ takeProfit()?.limit_price | price }}</span>
			</div>
		}

		@if (stopLoss()) {
			<div class="detail">
				<span class="title">{{ 'changeOrder.attributes.stop_loss' | translate }}</span>
				<span class="value">{{ stopLoss()?.stop_price | price }}</span>
			</div>
		}
	</div>

	@if (form) {
		<form
			class="form"
			[formGroup]="form"
			(ngSubmit)="onSubmit()"
		>
			@if (checkEditStopPrice()) {
				<app-order-price-input
					label="changeOrder.stopPrice"
					[control]="form.get('stop_price')"
				/>
			}

			@if (checkEditLimitPrice()) {
				@if (isLimitPriceVisible()) {
					<app-order-price-input
						label="changeOrder.limitPrice"
						[control]="form.get('limit_price')"
					/>
				}
			}

			<div class="change-group-order-sltp">
				<app-sl-tp-controls
					[isEnableBounds]="false"
					[allowToggle]="false"
					[defaultCalcField]="slTpValuesEnum.PRICE"
					[isBuy]="!order()?.is_short"
					[qty]="order()?.qty ?? 0"
					[targetPrice]="targetPrice()"
					[isActiveStopLoss]="isSlTpActive().stopLoss"
					[isActiveTakeProfit]="isSlTpActive().takeProfit"
					(changePriceStopLoss)="togglePriceSlTp('stop-loss', $event)"
					(changePriceTakeProfit)="togglePriceSlTp('take-profit', $event)"
					[defaultPriceStopLoss]="stopLoss()?.stop_price ?? 0"
					[defaultPriceTakeProfit]="takeProfit()?.limit_price ?? 0"
				/>
			</div>

			<div class="order-summary">
				<div class="item">
					<p class="label">{{ 'changeOrder.approximateSum' | translate }}:</p>
					<span class="value">{{ approximateSum() | price }}</span>
				</div>
				<div class="item">
					<p class="label">{{ 'changeOrder.availableFunds' | translate }}:</p>
					<span class="value">{{ alpacaAccount()?.buying_power ?? 0 | price }}</span>
				</div>
			</div>

			<app-button
				appearance="primary"
				size="m"
				type="submit"
				[isLoading]="isLoading()"
			>
				{{ 'changeOrder.confirm' | translate }}
			</app-button>
		</form>
	}
</div>
